/**
 * Acciones para listar usuarios en la gestión de usuarios para el rol supervisor
 * gu_lu_ = Gestión de Usuario (gu) _ Listar usuario (lu)
 */
import {Dispatch} from 'react'
import * as http from '../../../api/http'
import {ENDPOINTS} from '../../../api/config'
import {State} from '../../../reducers'
import {
  generalOpenModalError,
  generalOpenModalInfo,
  generalOpenModalMessage,
  generalOpenToastSuccess,
  generalShowLoader,
} from '../../general.actions'
import {GESTION_USUARIO_TYPES} from '../../../constants/gestionUsuario.types'
import {GestionUsuarioAction} from '../../../interfaces/gestion-usuarios.interace'
import {KEYS} from '../../../constants/keysStorage'
import {validacionesHandleChangeFacturador} from '../gu-generales/gu-generales'
import {quitarAcentos} from '../../../utils/strings.utils'
import jsPDF from 'jspdf'
import { pdfPerfilAddFooters, pdfPerfilAddHeaders, pdfPerfilTableEmisor, pdfPerfilTableSucursales, pdfPerfilTableUsuario } from '../../../utils/pdfPerfil'
import autoTable from 'jspdf-autotable'
import { gu_cu_setSucursalSeleccionada } from '../creacion-usuario/creacionUsuario.actions'

// ******************************************************************************************
export const gu_lu_setArrayUsuarios = (usuarios: Array<any>) => ({
  type: GESTION_USUARIO_TYPES.LU_SET_ARRAY_USUARIOS,
  payload: usuarios,
})

export const gu_lu_setUsuarios = (usuarios: Array<any>) => ({
  type: GESTION_USUARIO_TYPES.LU_SET_USUARIOS,
  payload: usuarios,
})

export const gu_lu_HandleChangeFormBuscar = (form: any) => ({
  type: GESTION_USUARIO_TYPES.LU_FORM_BUSCAR,
  payload: form,
})

export const gu_lu_ClearFormBuscar = () => ({
  type: GESTION_USUARIO_TYPES.LU_CLEAR_FORM_BUSCAR,
  payload: null,
})

export const gu_lu_Clear = () => ({
  type: GESTION_USUARIO_TYPES.LU_CLEAR,
  payload: null,
})

export const gu_lu_OpenModalAceptarRechazar = (flag: boolean) => ({
  type: GESTION_USUARIO_TYPES.LU_SHOW_MODAL_ACEPTAR_RECHAZAR,
  payload: flag,
})

export const gu_lu_OpenModalSucursales = (flag: boolean) => ({
  type: GESTION_USUARIO_TYPES.LU_SHOW_MODAL_SUCURSALES,
  payload: flag,
})

export const gu_lu_OpenModalResetPassword = (flag: boolean) => ({
  type: GESTION_USUARIO_TYPES.LU_SHOW_MODAL_RESET_PASSWORD,
  payload: flag,
})

export const gu_lu_OpenModalPrint = (flag: boolean) => ({
  type: GESTION_USUARIO_TYPES.LU_SHOW_MODAL_PRINT,
  payload: flag,
})

export const gu_lu_OpenModalEstatus = (flag: boolean) => ({
  type: GESTION_USUARIO_TYPES.LU_SHOW_MODAL_ESTATUS,
  payload: flag,
})

export const gu_lu_OpenModalEliminarUsuario = (flag: boolean) => ({
  type: GESTION_USUARIO_TYPES.LU_SHOW_MODAL_ELIMINAR_USUARIO,
  payload: flag,
})

export const gu_lu_SetSucursales = (sucursales: any) => ({
  type: GESTION_USUARIO_TYPES.LU_SET_SUCURSALES,
  payload: sucursales,
})

export const gu_lu_SetSucursalesSeleccionadas = (sucursales: Array<string>) => ({
  type: GESTION_USUARIO_TYPES.LU_SET_SUCURSALES_ASIGNADAS,
  payload: sucursales,
})

export const gu_lu_SetUsuarioSeleccionado = (usuario: any) => ({
  type: GESTION_USUARIO_TYPES.LU_SET_USUARIO_SELECCIONADO,
  payload: usuario,
})

// ******************************************************************************************
// ? FUNCIONES O PROCEDIMIENTOS SIN PETICIONES RES
// ******************************************************************************************
export const gu_lu_FormBuscarHandleChange =
  (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) =>
  async (dispatch: Dispatch<GestionUsuarioAction>) => {
    let {name, value} = e.target
    if (!validacionesHandleChangeFacturador(name, value)) return
    dispatch(gu_lu_HandleChangeFormBuscar({[name]: value}))
  }

export const gu_lu_BuscarUsuario =
  (flag: boolean = false) =>
  async (dispatch: Dispatch<GestionUsuarioAction>, getState: () => State) => {
    let arrayUsuarios = getState().gestionUsuario.listarUsuarios.arrayUsuarios
    if (arrayUsuarios.length === 0 && !flag)
      return dispatch(generalOpenModalError('No se encontró el usuario'))

    const {username, first_name, second_name, last_name, last_name2, id_number} =
      getState().gestionUsuario.listarUsuarios.formBuscar

    if (!username && !first_name && !second_name && !last_name && !last_name2 && !id_number)
      return dispatch(gu_lu_setUsuarios(arrayUsuarios))

    let newUsers: Array<any> = []

    arrayUsuarios.forEach((usuario) => {
      let encontrado = false
      if (username) encontrado = quitarAcentos(usuario?.username).includes(quitarAcentos(username))
      if (first_name)
        encontrado = quitarAcentos(usuario?.first_name).includes(quitarAcentos(first_name))
      if (second_name)
        encontrado = quitarAcentos(usuario?.second_name).includes(quitarAcentos(second_name))
      if (last_name)
        encontrado = quitarAcentos(usuario?.last_name).includes(quitarAcentos(last_name))
      if (last_name2)
        encontrado = quitarAcentos(usuario?.last_name2).includes(quitarAcentos(last_name2))
      if (id_number)
        encontrado = quitarAcentos(usuario?.id_number).includes(quitarAcentos(id_number))

      if (encontrado) newUsers.push(usuario)
    })
    dispatch(gu_lu_setUsuarios(newUsers))
  }

// ******************************************************************************************
// ? PETICIONES RES
// ******************************************************************************************
export const gu_lu_GetUsuarios = () => async (dispatch: Dispatch<any>, getState: () => State) => {
  if (getState().general.loader) return
  dispatch(generalShowLoader(true))
  await Promise.all([getUsuarios(dispatch), dispatch(gu_lu_getSucursales())])
  await await dispatch(generalShowLoader(false))
}

const getUsuarios = async (dispatch: Dispatch<GestionUsuarioAction>, msg: string = '') => {
  const username = localStorage.getItem(KEYS.USERNAME_CLIENTE)
  let message = msg || 'No se logró obtener información de los usuarios registrados.'
  await http
    .get(ENDPOINTS.GESTION_USUARIO_GET_USUARIOS, {username})
    .then(async (res: any) => {
      if (res?.data && Array.isArray(res.data)) {
        if (res.data.length > 0) {
          const userClean = res.data.filter((user: any) => !user?.username?.split('~')[1])
          dispatch(gu_lu_setArrayUsuarios(userClean))
          dispatch(gu_lu_setUsuarios(userClean))
        } else {
          dispatch(gu_lu_setArrayUsuarios([]))
          dispatch(gu_lu_setUsuarios([]))
          dispatch(generalOpenModalInfo('No existen usuarios registrados'))
        }
        return
      }
      dispatch(gu_lu_setArrayUsuarios([]))
      dispatch(gu_lu_setUsuarios([]))
      await dispatch(generalOpenModalError(message))
    })
    .catch(async (err: any) => {
      dispatch(gu_lu_setArrayUsuarios([]))
      dispatch(gu_lu_setUsuarios([]))
      await dispatch(
        generalOpenModalError(err?.response?.data?.message ?? message, err?.response?.data?.status)
      )
    })
}

export const gu_lu_getSucursales = () => async (dispatch: Dispatch<GestionUsuarioAction>) => {
  const userID = localStorage.getItem(KEYS.ID_CLIENT)

  let message = 'Existió un inconveniente al obtener las sucursales'
  await http
    .post(ENDPOINTS.GESTION_USUARIO_POST_SUCURSALES, {userID}, {}, KEYS.TOKEN)
    .then(async (res: any) => {
      if (!res?.message) {
        dispatch(gu_lu_SetSucursales(res.body))
        return
      }
      await dispatch(generalOpenModalError(res.message ?? message))
      dispatch(gu_lu_SetSucursales([]))
    })
    .catch(async (err: any) => {
      await dispatch(
        generalOpenModalError(err?.response?.data?.message ?? message, err?.response?.data?.status)
      )
      dispatch(gu_lu_SetSucursales([]))
    })
}

export const gu_lu_AceptarSolicitudUsuario =
  () => async (dispatch: Dispatch<any>, getState: () => State) => {
    if (getState().general.loader) return
    await dispatch(generalShowLoader(true))
    const sucursales = getState().gestionUsuario.listarUsuarios.sucursalesAsignadas

    if (sucursales.length === 0) {
      await dispatch(generalShowLoader(false))
      await dispatch(
        generalOpenModalInfo('Debe seleccionar al menos una sucursal al usuario.')
      )
      return
    }

    const body = {
      usuario_idusuario: String(getState().gestionUsuario.listarUsuarios.usuarioSeleccionado?.id),
      usuarioSucursal: sucursales.map((idSucursal) => ({sucursal_idsucursal: idSucursal})),
    }
    let error = true
    let message = 'Existió un inconveniente al asignar las sucursales'

    // Asignación de Sucursales -----------------------------------------------------------------------
    await http
      .post(ENDPOINTS.GESTION_USUARIO_POST_ASIGNAR_SUCURSALES, body, {}, KEYS.TOKEN)
      .then(async (res: any) => {
        if (!res.message) error = false
        else await dispatch(generalOpenModalError(res.message))
      })
      .catch(async (err: any) => {
        await dispatch(
          generalOpenModalError(
            err?.response?.data?.message ?? message,
            err?.response?.data?.status
          )
        )
      })

    // ================================================================================
    // Seleccionar sucursal por defecto
    dispatch(gu_cu_setSucursalSeleccionada(body.usuario_idusuario, sucursales[0]))

    if (error) {
      dispatch(generalShowLoader(false))
      return
    }

    await aceptarORechazarSolicitud(dispatch, getState, true)
    dispatch(generalShowLoader(false))
  }

export const gu_lu_RechazarSolicitudUsuario =
  () => async (dispatch: Dispatch<GestionUsuarioAction>, getState: () => State) => {
    if (getState().general.loader) return
    await aceptarORechazarSolicitud(dispatch, getState, false)
  }

const aceptarORechazarSolicitud = async (
  dispatch: Dispatch<GestionUsuarioAction>,
  getState: () => State,
  flag: boolean
) => {
  await dispatch(generalShowLoader(true))
  const body2 = {
    admin_id: String(localStorage.getItem(KEYS.ID_CLIENT)), // ID Supervisor
    user_id: String(getState().gestionUsuario.listarUsuarios.usuarioSeleccionado?.id), // ID Facturador
    state_req: flag,
    description: `Facturador ${flag ? 'aceptado' : 'rechazado'} por el supervisor`,
  }
  let message = `Existió un inconveniente al ${flag ? 'aceptar' : 'rechazar'} el usuario`

  // Aceptación de Usuario -----------------------------------------------------------------------
  await http
    .put(ENDPOINTS.GESTION_USUARIO_PUT_ACEPTAR_USUARIO, body2, {})
    .then(async (res: any) => {
      if (res.status === 200) {
        let message = 'Existió un inconveniente al actualizar la tabla de usuarios.'
        await getUsuarios(dispatch, message)

        dispatch(
          generalOpenModalMessage(
            `Usuario ${flag ? 'Aceptado' : 'Rechazado'}`,
            `El usuario ha sido ${flag ? 'aceptado' : 'rechazado'} exitosamente`
          )
        )
        dispatch(gu_lu_ClearFormBuscar())
        dispatch(gu_lu_OpenModalAceptarRechazar(false))
        dispatch(gu_lu_OpenModalSucursales(false))
        dispatch(gu_lu_SetUsuarioSeleccionado(null))
        return
      }
      dispatch(generalOpenModalError(res?.data?.message ?? message))
    })
    .catch((err: any) => {
      dispatch(
        generalOpenModalError(err?.response?.data?.message ?? message, err?.response?.data?.status)
      )
    })
    .finally(() => dispatch(generalShowLoader(false)))
}

export const gu_lu_ResetPasswordConfirm =
  () => async (dispatch: Dispatch<GestionUsuarioAction>, getState: () => State) => {
    if (getState().general.loader) return
    await dispatch(generalShowLoader(true))
    const body = {
      username: getState().gestionUsuario.listarUsuarios.usuarioSeleccionado?.username,
    }
    let message = 'Existió un problema al reiniciar la contraseña, inténtelo nuevamente'
    await http
      .post(ENDPOINTS.GESTION_USUARIO_POST_RESET_PASSWORD_CLIENTES, body)
      .then(async (res: any) => {
        if (res.data) {
          let message = 'Existió un inconveniente al actualizar la tabla de usuarios.'
          await getUsuarios(dispatch, message)

          dispatch(
            generalOpenToastSuccess(
              `Se ha iniciado el proceso de reestablecimiento de contraseña para el usuario ${body.username}.`
            )
          )
          dispatch(gu_lu_ClearFormBuscar())
          dispatch(gu_lu_OpenModalResetPassword(false))
          dispatch(gu_lu_SetUsuarioSeleccionado(null))
          return
        }
        dispatch(generalOpenModalError(res.message ?? message))
      })
      .catch((err: any) => {
        dispatch(
          generalOpenModalError(
            err?.response?.data?.message ?? message,
            err?.response?.data?.status
          )
        )
      })
      .finally(() => dispatch(generalShowLoader(false)))
  }

export const gu_lu_EliminarUsuarioConfirm =
  () => async (dispatch: Dispatch<GestionUsuarioAction>, getState: () => State) => {
    if (getState().general.loader) return
    await dispatch(generalShowLoader(true))
    const body = {
      admin_id: String(localStorage.getItem(KEYS.ID_CLIENT)), // ID Supervisor
      user_id: String(getState().gestionUsuario.listarUsuarios.usuarioSeleccionado?.id), // ID Facturador
      type: 1
    }
    let message = 'Existió un problema al eliminar el usuario, inténtelo nuevamente'
    await http
      ._delete(ENDPOINTS.GESTION_USUARIO_DELETE_USUARIO, body)
      .then(async (res: any) => {
        if (res.status === 200) {
          let message = 'Existió un inconveniente al actualizar la tabla de usuarios.'
          await getUsuarios(dispatch, message)

          dispatch(
            generalOpenModalMessage(
              `Usuario Eliminado`,
              `El usuario ha sido eliminado exitosamente`
            )
          )
          dispatch(gu_lu_ClearFormBuscar())
          dispatch(gu_lu_OpenModalEliminarUsuario(false))
          dispatch(gu_lu_SetUsuarioSeleccionado(null))
          return
        }
        dispatch(generalOpenModalError(res.message ?? message))
      })
      .catch((err: any) => {
        dispatch(
          generalOpenModalError(
            err?.response?.data?.message ?? message,
            err?.response?.data?.status
          )
        )
      })
      .finally(() => dispatch(generalShowLoader(false)))
  }

export const gu_lu_AsignarDesasignarSucurales =
  () => async (dispatch: Dispatch<any>, getState: () => State) => {
    if (getState().general.loader) return
    await dispatch(generalShowLoader(true))
    const sucursales = getState().gestionUsuario.listarUsuarios.sucursalesAsignadas

    if (sucursales.length === 0) {
      dispatch(generalShowLoader(false));
      dispatch(generalOpenModalInfo(`Debe seleccionar al menos una sucursal al usuario.`))
      return;
    }

    const body = {
      usuario_idusuario: String(getState().gestionUsuario.listarUsuarios.usuarioSeleccionado?.id),
      usuarioSucursal: sucursales.map((idSucursal) => ({sucursal_idsucursal: idSucursal})),
    }
    let message = 'Existió un inconveniente al asignar las sucursales'
    // Asignación de Sucursales -----------------------------------------------------------------------
    await http
      .post(ENDPOINTS.GESTION_USUARIO_POST_ASIGNAR_SUCURSALES, body, {}, KEYS.TOKEN)
      .then(async (res: any) => {
        if (!res.message) {
          if (sucursales.length === 0) {
            dispatch(
              generalOpenModalMessage(
                `Asignación actualizada`,
                `El cliente ha sido desvinculado de todas sus sucursales y no actualmente no puede realizar transacciones.`
              )
            )
          } else {
            dispatch(
              generalOpenModalMessage(
                `Asignación actualizada`,
                `Las sucursales asignadas al cliente fueron actualizadas correctamente.`
              )
            )
          }
          
          // ================================================================================
          // Seleccionar sucursal por defecto
          dispatch(gu_cu_setSucursalSeleccionada(body.usuario_idusuario, sucursales[0]))

          let message = 'Existió un inconveniente al actualizar la tabla de usuarios.'
          await getUsuarios(dispatch, message)
          dispatch(gu_lu_ClearFormBuscar())
          dispatch(gu_lu_OpenModalAceptarRechazar(false))
          dispatch(gu_lu_OpenModalSucursales(false))
          dispatch(gu_lu_SetUsuarioSeleccionado(null))
          return
        }
        await dispatch(generalOpenModalError(res.message))
      })
      .catch(async (err: any) => {
        await dispatch(
          generalOpenModalError(
            err?.response?.data?.message ?? message,
            err?.response?.data?.status
          )
        )
      })
      .finally(() => dispatch(generalShowLoader(false)))
  }

export const gu_lu_generarPDF =
  () => async (dispatch: Dispatch<GestionUsuarioAction>, getState: () => State) => {
    const {usuarioSeleccionado} = getState().gestionUsuario.listarUsuarios;
    const {datosEmisor: formClient, tipoDocumento, tipoEstablecimientos} = getState().catalogos;
    const pdf = new jsPDF();
    
    const tipoEstablecimiento = tipoEstablecimientos.find((tipo) => tipo.codigo === formClient.tipoestablecimiento);
    const docCliente = tipoDocumento.find((doc) => doc.codigo === usuarioSeleccionado.type_id_number);
    const bodyTableSucursales = usuarioSeleccionado.sucursales
        .map((sucu: any) => {
          const sucursal = sucu.Sucursal;
          return sucursal ? [sucursal.nombre, sucursal.direccion] : null;
        })
        .filter(Boolean);

    const tablaDatosDeUsuario = pdfPerfilTableUsuario({...usuarioSeleccionado, nombreTipoDocumento: docCliente?.valor});
    const tablaDatosDeEmisor = pdfPerfilTableEmisor({...formClient, desTipoEstablecimiento: tipoEstablecimiento?.valor});
    const tablaSucursales = pdfPerfilTableSucursales(bodyTableSucursales);

    // AGREGAR HEADER
    pdfPerfilAddHeaders(pdf, formClient, usuarioSeleccionado, false);
    // AGREGAR TABLAS
    autoTable(pdf, tablaDatosDeUsuario);
    autoTable(pdf, tablaDatosDeEmisor);
    autoTable(pdf, tablaSucursales);
    // AGREGAR FOOTER
    pdfPerfilAddFooters(pdf);

    pdf.save(`Usuario_${usuarioSeleccionado.username}.pdf`);

    // Crear un objeto para guardar el contenido del PDF
    const pdfContent = {
      tablaDatosDeUsuario,
      tablaDatosDeEmisor,
      tablaSucursales,
    };

    // Devolver el contenido del PDF en lugar de guardarlo o imprimirlo
    return pdfContent;

  }

export const gu_lu_changeEstatus =
  () => async (dispatch: Dispatch<GestionUsuarioAction>, getState: () => State) => {
    if (getState().general.loader) return
    await dispatch(generalShowLoader(true))

    const {usuarioSeleccionado} = getState().gestionUsuario.listarUsuarios;
    const {datos: datosSupervisor} = getState().userLogin;
    const accion = usuarioSeleccionado.accionEstatus;
    
    if (!accion) {
      // DESACTIVAR
      const body = {
        admin_id: datosSupervisor.id, // ID Supervisor
        user_id: String(usuarioSeleccionado?.id), // ID Facturador
        type: 0
      }

      let messageErr = 'Existió un problema al desactivar el usuario, inténtelo nuevamente'
      await http
        ._delete(ENDPOINTS.GESTION_USUARIO_DELETE_USUARIO, body)
        .then(async (res: any) => {
          if (res.status === 200) {
            let message = 'Existió un inconveniente al actualizar la tabla de usuarios.'
            await getUsuarios(dispatch, message)
            dispatch(
              generalOpenModalMessage(
                `Usuario desactivado`,
                `El usuario ha cambiado su estatus exitosamente`
              )
            )
            await dispatch(gu_lu_OpenModalEstatus(false));
            return;
          }
          dispatch(generalOpenModalError(res.message ?? messageErr))
        })
        .catch((err: any) => {
          dispatch(
            generalOpenModalError(
              err?.response?.data?.message ?? messageErr,
              err?.response?.data?.status
            )
          )
        })
        .finally(() => dispatch(generalShowLoader(false)))
    } else {
      // ACTIVAR
      const body = {
        admin_id: datosSupervisor.id, // ID Supervisor
        user_id: String(usuarioSeleccionado?.id), // ID Facturador
      }

      let messageErr = 'Existió un problema al activar el usuario, inténtelo nuevamente'
      await http
        .put(ENDPOINTS.GESTION_USUARIO_DELETE_USUARIO, body)
        .then(async (res: any) => {
          if (res.status === 200) {
            let message = 'Existió un inconveniente al actualizar la tabla de usuarios.'
            await getUsuarios(dispatch, message)
            dispatch(
              generalOpenModalMessage(
                `Usuario activado`,
                `El usuario ha cambiado su estatus exitosamente`
              )
            )
            await dispatch(gu_lu_OpenModalEstatus(false));
            return;
          }
          dispatch(generalOpenModalError(res.message ?? messageErr))
        })
        .catch((err: any) => {
          dispatch(
            generalOpenModalError(
              err?.response?.data?.message ?? messageErr,
              err?.response?.data?.status
            )
          )
        })
        .finally(() => dispatch(generalShowLoader(false)))
    }   
}